<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          Review Organization Info
        </p>
      </header>
      <section class="modal-card-body">
        <div class="flex -mx-5 my-4">
          <d-field label="Current Organization ID" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.filemakerOrganizationId" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.filemakerOrganizationId = newSubmittedInfo.filemakerOrganizationId" />
            </d-tooltip>
          </div>
          <d-field label="Existing Organization ID" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.filemakerOrganizationId" />
          </d-field>
        </div>
        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Company Name" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.name" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.name = newSubmittedInfo.name" />
            </d-tooltip>
          </div>
          <d-field label="Existing Company Name" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.name" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Business Type" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.businessType" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.businessType = newSubmittedInfo.businessType" />
            </d-tooltip>
          </div>
          <d-field label="Existing Business Type" class="w-5/12 px-5">
            <d-select v-model="newExistingInfo.businessType" expanded>
              <option value="Corporation">
                Corporation
              </option>
              <option value="Partnership">
                Partnership
              </option>
              <option value="Sole Proprietorship">
                Sole Proprietorship
              </option>
              <option value="Other">
                Other
              </option>
            </d-select>
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Address Line 1" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.addressLine1" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.addressLine1 = newSubmittedInfo.addressLine1" />
            </d-tooltip>
          </div>
          <d-field label="Existing Address Line 1" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.addressLine1" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Address Line 2" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.addressLine2" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.addressLine2 = newSubmittedInfo.addressLine2" />
            </d-tooltip>
          </div>
          <d-field label="Existing Address Line 2" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.addressLine2" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted City" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.city" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.city = newSubmittedInfo.city" />
            </d-tooltip>
          </div>
          <d-field label="Existing City" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.city" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted State" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.state" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.state = newSubmittedInfo.state" />
            </d-tooltip>
          </div>
          <d-field label="Existing State" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.state" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Zip/Postal" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.zip" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.zip = newSubmittedInfo.zip" />
            </d-tooltip>
          </div>
          <d-field label="Existing Zip/Postal" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.zip" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Country" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.country" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.country = newSubmittedInfo.country" />
            </d-tooltip>
          </div>
          <d-field label="Existing Country" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.country" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Website URL" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.websiteUrl" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.websiteUrl = newSubmittedInfo.websiteUrl" />
            </d-tooltip>
          </div>
          <d-field label="Existing Website URL" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.websiteUrl" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Phone #" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.phone" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.phone = newSubmittedInfo.phone" />
            </d-tooltip>
          </div>
          <d-field label="Existing Phone #" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.phone" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Fax #" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.fax" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.fax = newSubmittedInfo.fax" />
            </d-tooltip>
          </div>
          <d-field label="Existing Fax #" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.fax" />
          </d-field>
        </div>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Close
        </d-btn>
        <d-btn type="submit">
          Save Changes
        </d-btn>
      </footer>
    </div>
  </form>
</template>
<script>
  export default {
    props: {
      submittedInfo: {
        type: Object,
        default: () => ({}),
      },

      existingInfo: {
        type: Object,
        default: () => ({}),
      },
    },

    data() {
      return {
        newSubmittedInfo: JSON.parse(JSON.stringify(this.submittedInfo)),
        newExistingInfo: JSON.parse(JSON.stringify(this.existingInfo)),
      };
    },

    mounted() {
      this.copyExcessInfo();
    },

    methods: {
      copyExcessInfo() {
        this.newExistingInfo.source = this.newSubmittedInfo.source;
        this.newExistingInfo.id = this.newSubmittedInfo.id;
      },

      saveForm() {
        this.$parent.events.setRevisedInfo(this.newExistingInfo);
        this.$parent.close();
        this.$toast.success('Info has been updated');
      },
    },
  };
</script>